import { createModel } from '@rematch/core';
import { PurchaseOrder } from '../dto';
import type { RootModel } from './index';
import { bulkCreateShipments } from '../services/purchaseOrders';

export type ShipmentsState = PurchaseOrder[];

export const shipments = createModel<RootModel>()({
  state: [] as PurchaseOrder[],
  reducers: {
    createBulk: (state: ShipmentsState, payload: PurchaseOrder[]) => [...payload, ...state],
    bulkCreate: (state: ShipmentsState, payload: PurchaseOrder[]) => state,
  },
  effects: (dispatch) => ({
    async createShipment(payload: PurchaseOrder[]): Promise<void> {
      dispatch.shipments.createBulk(payload);
    },
    async bulkCreateShipments(payload: PurchaseOrder[]): Promise<number> {
      const { id, purchaseOrders = [] } = await bulkCreateShipments(payload);
      dispatch.shipments.bulkCreate(purchaseOrders);
      return id;
    },
  }),
});
